import { Injectable, inject } from "@angular/core";
import { FormGroup, AbstractControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

Injectable({
    providedIn: "root",
});
export class ValidationService {
    private translateService = inject(TranslateService);

    /**
     * Get Form-Control.
     * @param form
     * @param fieldName
     * @returns fieldName
     */
    private findFieldControl(
        form: FormGroup,
        fieldName: string
    ): AbstractControl {
        return fieldName ? form.get(fieldName) : form;
    }

    /**
     * Check if field isValid.
     * @param form
     * @param fieldName
     * @returns boolean
     */
    isValidField(form: FormGroup, fieldName: string): boolean {
        const control = this.findFieldControl(form, fieldName);

        return control.invalid && (control.dirty || control.touched);
    }

    getErrorMessage(
        form: FormGroup,
        fieldName: string,
        textName: string,
        textMatchingTo?: string
    ) {
        const control = this.findFieldControl(form, fieldName);
        const text = textName ? textName : fieldName;
        let message: string = "";

        if (control.hasError("email")) {
            message = this.translateService.instant("validations.email");
        } else if (control.hasError("required")) {
            message = this.translateService.instant("validations.required");
        } else if (control.hasError("min")) {
            const minValue = control.errors?.min.min;
            message =
                this.translateService.instant(`${text}`) +
                this.translateService.instant("validations.minValue", {
                    number: minValue,
                });
        } else if (control.hasError("maxlength")) {
            const maxValue = control.errors?.maxlength.requiredLength;
            message =
                this.translateService.instant(`${text}`) +
                this.translateService.instant("validations.maxLength", {
                    number: maxValue,
                });
        } else if (control.hasError("minlength")) {
            const maxValue = control.errors?.minlength.requiredLength;
            message =
                this.translateService.instant(`${text}`) +
                this.translateService.instant("validations.minLength", {
                    number: maxValue,
                });
        } else if (control.hasError("notEqualPassword")) {
            message = this.translateService.instant(
                "validations.notEqualPassword"
            );
        } else if (control.hasError("isValidPhone")) {
            message = this.translateService.instant("validations.phone");
        } else if (control.hasError("pattern")) {
            if (
                fieldName.includes("phoneNumber") ||
                fieldName.includes("msisdn")
            ) {
                message = this.translateService.instant("validations.phone");
            }
            // else if (fieldName.includes("password")) {
            // message = this.translateService.instant("validations.password");
            // }
        }

        return message;
    }
}
